import { SourceType } from './field-meta';
export var QueryCombinerType = /*#__PURE__*/ function(QueryCombinerType) {
    QueryCombinerType["Any"] = "any";
    QueryCombinerType["All"] = "all";
    return QueryCombinerType;
}({});
/** Shared with `components/pages/types` — keep in sync with SourceType. */ export var FilterGroupType = function(FilterGroupType) {
    FilterGroupType[FilterGroupType["Task"] = SourceType.Task] = "Task";
    FilterGroupType[FilterGroupType["Project"] = SourceType.Project] = "Project";
    FilterGroupType[FilterGroupType["User"] = SourceType.User] = "User";
    FilterGroupType[FilterGroupType["Phase"] = SourceType.Phase] = "Phase";
    FilterGroupType[FilterGroupType["Timesheet"] = SourceType.Timesheet] = "Timesheet";
    FilterGroupType[FilterGroupType["Role"] = SourceType.Role] = "Role";
    FilterGroupType[FilterGroupType["StarMeta"] = SourceType.StarMeta] = "StarMeta";
    FilterGroupType[FilterGroupType["ActualStarMeta"] = SourceType.ActualStarMeta] = "ActualStarMeta";
    FilterGroupType[FilterGroupType["EstimatedStarMeta"] = SourceType.EstimatedStarMeta] = "EstimatedStarMeta";
    FilterGroupType[FilterGroupType["ResourceRequest"] = SourceType.ResourceRequest] = "ResourceRequest";
    FilterGroupType[FilterGroupType["Invoice"] = SourceType.Invoice] = "Invoice";
    FilterGroupType[FilterGroupType["CreditNote"] = SourceType.CreditNote] = "CreditNote";
    FilterGroupType[FilterGroupType["Financial"] = SourceType.Financial] = "Financial";
    FilterGroupType[FilterGroupType["Company"] = SourceType.Company] = "Company";
    FilterGroupType[FilterGroupType["Formula"] = SourceType.Formula] = "Formula";
    FilterGroupType[FilterGroupType["Expense"] = SourceType.Expense] = "Expense";
    FilterGroupType[FilterGroupType["Sheet"] = SourceType.Sheet] = "Sheet";
    FilterGroupType[FilterGroupType["ExpenseReport"] = SourceType.ExpenseReport] = "ExpenseReport";
    FilterGroupType[FilterGroupType["RevenueEntry"] = SourceType.RevenueEntry] = "RevenueEntry";
    FilterGroupType[FilterGroupType["Policy"] = SourceType.Policy] = "Policy";
    FilterGroupType[FilterGroupType["ProjectFinancialBudget"] = SourceType.ProjectFinancialBudget] = "ProjectFinancialBudget";
    FilterGroupType[FilterGroupType["ResourceAllocation"] = SourceType.ResourceAllocation] = "ResourceAllocation";
    FilterGroupType[FilterGroupType["Signal"] = SourceType.Signal] = "Signal";
    return FilterGroupType;
}({});
